var itemsFre = {
    "100": "Hardi",         // Hardy
    "101": "Solo",          // Lonely
    "102": "Brave",         // Brave
    "103": "Rigide",        // Adamant
    "104": "Mauvais",       // Naughty
    "105": "Assuré",        // Bold
    "106": "Docile",        // Docile
    "107": "Relax",         // Relaxed
    "108": "Malin",         // Impish
    "109": "Lâche",         // Lax
    "110": "Timide",        // Timid
    "111": "Pressé",        // Hasty
    "112": "Sérieux",       // Serious
    "113": "Jovial",        // Jolly
    "114": "Naïf",          // Naive
    "115": "Modeste",       // Modest
    "116": "Doux",          // Mild
    "117": "Discret",       // Quiet
    "118": "Pudique",       // Bashful
    "119": "Foufou",        // Rash
    "120": "Calme",         // Calm
    "121": "Gentil",        // Gentle
    "122": "Malpoli",       // Sassy
    "123": "Prudent",       // Careful
    "124": "Bizarre"        // Quirky
};
export default itemsFre;